import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useQuery } from '@tanstack/react-query';
import { docsQueries } from './docs.queries';
import { findGroup, getNodeLabel } from './docs.tree';
import { DocsGroupTree } from './docs.tree-view';

/**
 * Panel rendered when the URL drills into a docs group. The route segment is
 * `:groupOrFileId/group` (recursive at every depth); the panel's own group id
 * lives in `params.groupOrFileId`. The root catalog tree is rendered by the
 * project /docs tab body — there is no panel for the catalog root itself.
 *
 * Selection highlight (which child row is currently drilled into) is a
 * future concern handled by reading the URL beyond `basePath` via
 * useStackPath; it is not encoded in a route slot.
 */
export const DocsGroupPanel = ({
  params,
  parentParams,
  basePath,
  ...panelProps
}: RoutedPanelProps) => {
  const projectId = parseInt(parentParams.projectId ?? params.projectId);
  const groupId = parseInt(params.groupOrFileId);

  const { data: rows } = useQuery(docsQueries.byProject(projectId));
  const group = rows ? findGroup(rows, groupId) : null;
  const title = group ? getNodeLabel(group) : `Group ${groupId}`;

  return (
    <Panel {...panelProps} title={title}>
      <DocsGroupTree
        projectId={projectId}
        groupId={groupId}
        basePath={basePath}
      />
    </Panel>
  );
};
